import React, { useState,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';

export default function AddSubdivisioneForm() {
  const [formData, setFormData] = useState({
    id: '',
    descripcion: '',
    divisioneId: '1'
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  
  useEffect(() => {
    const fetchNextId = async () => {
        try {
            const response = await axios.get('/subdivisiones');
            const lastId = response.data.reduce((maxId, subdivisione) => Math.max(maxId, subdivisione.id), 0);
            setFormData(prev => ({ ...prev, id: lastId + 1 }));
        } catch (error) {
            console.error('Error obteniendo el próximo ID:', error);
        }
    };
    fetchNextId();
}, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: '' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validación básica
    const validationErrors = {};
    if (!formData.id) validationErrors.id = 'El campo ID es obligatorio.';
    if (!formData.descripcion) validationErrors.descripcion = 'El campo Descripción es obligatorio.';
    if (!formData.divisioneId) validationErrors.divisioneId = 'El campo Zona es obligatorio.';

    if (Object.keys(validationErrors).length === 0) {
      setIsLoading(true);
      try {
        console.log('Datos enviados al backend:', formData);
        await axios.post('/subdivisiones', {
          id: parseInt(formData.id, 10),
          descripcion: formData.descripcion,
          divisioneId: parseInt(formData.divisioneId, 10)
        });
        navigate('/home/subdivisiones');
      } catch (err) {
        console.error('Error saving zona:', err);
        setErrors({ submit: 'Error al guardar la zona. Por favor, intente de nuevo.' });
      } finally {
        setIsLoading(false);
      }
    } else {
      setErrors(validationErrors);
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h2 className="text-2xl font-semibold mb-6">Añadir Nueva Zona</h2>
      <form onSubmit={handleSubmit} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="id">
            ID
          </label>
          <input
            type="text"
            name="id"
            value={formData.id}
            onChange={handleChange}
            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.id ? 'border-red-500' : ''}`}
            placeholder="ID de la zona"
          />
          {errors.id && <p className="text-red-500 text-xs italic">{errors.id}</p>}
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="descripcion">
            Descripción
          </label>
          <input
            type="text"
            name="descripcion"
            value={formData.descripcion}
            onChange={handleChange}
            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.descripcion ? 'border-red-500' : ''}`}
            placeholder="Descripción de la zona"
          />
          {errors.descripcion && <p className="text-red-500 text-xs italic">{errors.descripcion}</p>}
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="divisioneId">
            Area ID
          </label>
          <input
            type="text"
            name="divisioneId"
            value={formData.divisioneId}
            onChange={handleChange}
            className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.divisioneId ? 'border-red-500' : ''}`}
            placeholder="ID del area asociada"
          />
          {errors.divisioneId && <p className="text-red-500 text-xs italic">{errors.divisioneId}</p>}
        </div>
        {errors.submit && <p className="text-red-500 text-xs italic mb-4">{errors.submit}</p>}
        <div className="flex items-center justify-between">
          <button
            type="submit"
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            disabled={isLoading}
          >
            {isLoading ? 'Guardando...' : 'Guardar Zona'}
          </button>
        </div>
      </form>
    </div>
  );
}

